import { Modal, Table } from "antd";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";

function TemplateModal(props: any) {
  const currentRecord = useSelector((state: RootState) => state.OrganizationsPageState.currentRecord);

  const TemplateModalContent = () => {
    return (
      <div style={{ width: "100%" }}>
        <h4> Templates</h4>
        <Table
          columns={[
            {
              title: "Name",
              dataIndex: "",
              key: "name",
              render: (text: string) => <a>{text}</a>,
            },
          ]}
          className="table"
          dataSource={currentRecord.templates}
          pagination={{
            pageSize: 5,
          }}
          scroll={{ y: 300 }}
          size="small"
          bordered
        />
      </div>
    );
  };

  return (
    <Modal
      centered
      zIndex={1500}
      footer={[]}
      onCancel={() => props.close()}
      open={props.openState}>
      <TemplateModalContent />
    </Modal>
  );
}

export default TemplateModal;
